import '../../../css/modal.css';
import { createFetchTableData } from '../../../utils/createFetchTableData';
import { useState, useEffect, useCallback, useMemo } from "react";
import MonitorModal from './MonitorModal';
import Datatable from "../../../components/ui/Datatable";
import { promedioStatusContrato } from "../../../utils/funciones";
import { post, getUno } from '../../../api/apis';
import { mensajeSimple, modalCargando } from '../../../components/ui/sweetAlerts';
import { BtnEnviarGenerarExcel } from '../../../components/BtnObtenerExcel';

const MonitorConfirmalo = () => {
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    // Configuración de orden inicial para el datatable
    const initialSortBy = 'IdLote';
    const initialSortDir = 'desc';

    // --- LÓGICA DE DATOS PARA DATATABLE ---
    // Se entrega el endpoint del cual se obtendrán los datos y donde se encuentran los datos dentro de la respuesta para armar la tabla
    const fetchTableData = useMemo(() =>
        createFetchTableData({
            url: 'monitor/confirmalo',
            initialSortBy, // columna por defecto
            initialSortDir, // dirección por defecto
            dataPath: ['data', 'data', 'data'], // ruta dentro de la respuesta donde se encuentran los datos
            totalPath: ['data', 'data', 'total'] // ruta dentro de la respuesta donde se encuentra el total
        })
        , [initialSortBy, initialSortDir]);

    // --- LÓGICA DE REENVÍO DE CONTRATO ---
    const reenviarContrato = async (id) => {
        modalCargando('Reenviando');
        const resp = await post('reenvio_contrato', { id_contrato: id });
        if (resp.data.status === 'info') { mensajeSimple('info', resp.data.message, 4500); }
        else if (resp.data.status === 'success') {
            mensajeSimple(resp.data.status, resp.data.message, 4000);
            // Aquí podrías refrescar la tabla si lo necesitas
        }
        else { mensajeSimple('error', 'Ha ocurrido un error.'); }
    };

    const BtnReenvio = ({ dato, id }) => (
        dato === '1'
            ? <button onClick={() => reenviarContrato(id)} className='btn btn-primary btn-sm'>Reenviar</button>
            : null
    );

    // Cerrar modal al presionar Escape o clic fuera del modal
    useEffect(() => {
        if (!showModal) return;
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                setShowModal(false);
            }
        };
        const handleClickOutside = (e) => {
            // Si el modal está abierto y el clic no es dentro del contenido del modal
            const modalContent = document.querySelector('.modal-content');
            if (modalContent && !modalContent.contains(e.target)) {
                setShowModal(false);
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('mousedown', handleClickOutside);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showModal]);


    // Manejar doble clic en una fila para abrir el modal
    const handleRowDoubleClick = (rowData) => {
        setSelectedRow(rowData);
        setShowModal(true);
    };

    // --- DEFINICIÓN DE COLUMNAS (MEMORIZADA) ---
    const columnsDef = useMemo(() => [
        { label: 'Id envío', sortable: true, searchForColumn: true, key: 'IdLote', selector: row => row.IdLote, headerAlign: 'left', dataAlign: 'left', width: '50px' },
        { label: 'N° Personal', sortable: true, searchForColumn: true, key: 'NPersonal', selector: row => row.NPersonal, headerAlign: 'left', dataAlign: 'left', width: '50px' },
        { label: 'Nombre colaborador', sortable: true, searchForColumn: true, key: 'Nombre', selector: row => row.Nombre, headerAlign: 'left', dataAlign: 'left', width: '50px' },
        { label: 'RUT', sortable: true, searchForColumn: true, key: 'Rut', selector: row => row.Rut, headerAlign: 'left', dataAlign: 'left', width: '50px' },
        { label: 'División', sortable: true, searchForColumn: true, key: 'Division', selector: row => row.Division, headerAlign: 'left', dataAlign: 'left', width: '50px' },
        { label: 'Unidad organizativa', sortable: true, searchForColumn: true, key: 'TextoUnidadOrganizativa', selector: row => row.TextoUnidadOrganizativa, headerAlign: 'left', dataAlign: 'left', width: '50px' },
        { label: 'Subdivisión', sortable: true, searchForColumn: true, key: 'Subdivision', selector: row => row.Subdivision, headerAlign: 'left', dataAlign: 'left', width: '50px' },
        { label: 'Cargo', sortable: true, searchForColumn: true, key: 'Cargo', selector: row => row.Cargo, headerAlign: 'left', dataAlign: 'left', width: '100px' },
        { label: 'Fecha ingreso', sortable: true, searchForColumn: true, key: 'FechaIngreso', selector: row => row.FechaIngreso && row.FechaIngreso.replace(/\./g, '-'), headerAlign: 'left', dataAlign: 'left', width: '50px' },
        { label: 'Emisión contrato', sortable: true, searchForColumn: true, key: 'FechaEmisionContrato', selector: row => row.FechaEmisionContrato && row.FechaEmisionContrato.replace(/\./g, '-'), headerAlign: 'left', dataAlign: 'left', width: '50px' },
        { label: 'ID Tramite', sortable: false, searchForColumn: false, key: 'id_wf', selector: row => row.id_wf ? row.id_wf : '---', headerAlign: 'left', dataAlign: 'left', width: '50px' },
        { label: '% Avance', sortable: false, searchForColumn: false, key: 'estado_contratos', selector: row => promedioStatusContrato(row.estado_contratos), headerAlign: 'left', dataAlign: 'left', width: '50px' },
        { label: 'Recordatorio', sortable: true, searchForColumn: false, key: 'reenvio_contrato', selector: row => <BtnReenvio dato={row.reenvio_contrato} id={row.id} />, headerAlign: 'left', dataAlign: 'center', width: '50px' },
    ], []);


    return (
        <>
            {/* datatabla dinámico con los datos del monitor */}
            <Datatable
                titletable="Monitor Confirmalo"
                requestDataFn={fetchTableData}
                initialPerPage={10}
                columns={columnsDef}
                orderColumns={true}
                adjustColumnSize={true}
                searchEnabled={true}
                searchColumnsEnabled={true}
                manualPageInput={true}
                onRowDoubleClick={handleRowDoubleClick}
                rowsPerPageOptions={[10, 20, 50, 100]}
                initialSortBy={initialSortBy}
                initialSortDir={initialSortDir}
            // checkboxColumn={true}
            />

            {/* Boton para descargar excel */}
            <div className="row mt-3">
                <div className="col-sm-12">
                    <BtnEnviarGenerarExcel ubicacionArchivo="excelMonitor/ReporteDataMonitorConfirmalo.xlsx" agregarFecha={true} />
                </div>
            </div>

            {/* Modal de detalles del registro */}
            <MonitorModal show={showModal} row={selectedRow} onClose={() => setShowModal(false)} />
        </>
    );
};

export default MonitorConfirmalo;
